module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e90615"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_con6_r1#d7e2698",
      "id": "d14e522"
    }
  }, [_c('b', [_vm._v("PART I")])]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_con6_r1#d7e2698",
      "id": "d14e526"
    }
  }, [_c('i', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSIDE")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OB")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b24d9be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Brue_ISBN9781936070282_epub_c8_r1.vue
// module id = 81
// module chunks = 0